<template>
  <Loader :value="promises.fetch" class="task-external view" :message="$metaInfo.title">
    <div v-if="image" class="task-external__cover">
      <div class="task-external__cover-wrapper">
        <img :src="image.url" :alt="image.name" />
      </div>
    </div>
    <div class="task-external__wrapper">
      <div
        v-if="reference && ['ResidentialAccount', 'Residential', 'Product', 'Shop'].includes(data.reference.onModel)"
        class="task-external__reference card card--default"
      >
        <div class="card__content">
          <span
            >{{ $tc(data.type === 'complaint' ? 'complaint' : 'task', 1) }} {{ $t('connected').toLowerCase() }}
            {{ $tc('unit', 1).toLowerCase() }}</span
          >
          <h1>{{ reference.displayName || reference.number }}</h1>
          <p>{{ reference.discription }}</p>
        </div>
      </div>
      <div class="task-external__content">
        <Card class="task-external__info">
          <template #header>
            <h2>{{ $metaInfo.title }}</h2>
          </template>
          <template>
            <Metadata :item="data"></Metadata>
            <div class="task-external__info-description">
              <div v-html="data.description"></div>
            </div>
            <FileComponent
              v-if="data.attachments && data.attachments.length"
              :label="$tc('attachment', 2)"
              :value="data.attachments"
              readonly
            />
            <Thumbnails
              class="mt-2"
              v-if="data.images && data.images.length"
              :label="$tc('image', 2)"
              :value="data.images"
            />
          </template>
        </Card>

        <Comments
          v-if="comments.length"
          scope="Task"
          :value="comments"
          :readonly="true"
          class="task-external__comments"
          theme="flat"
        >
          <template #header>
            <h2>{{ $tc('message', 2) }}</h2>
            <span v-if="data.type === 'complaint'">{{ $t('externalComplaintDialogSublabel') }}</span>
          </template>
        </Comments>
      </div>
    </div>
  </Loader>
</template>

<script>
import fetch from '@/fetch'
import Metadata from '@/components/Task/Metadata'
import Comments from '@/components/Comment/List'
import Thumbnails from '@/components/Thumbnails/Component'
import { FileComponent } from '@kvass/file'
import Card from '@/components/Card'
import getCoverThumbnail from '@/utils/getCoverThumbnail'

export default {
  mixins: [],
  props: {
    id: String,
    token: String,
    returnTo: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      promises: {
        submit: null,
        fetch: null,
      },
      data: {},
      comments: [],
    }
  },

  computed: {
    reference() {
      return this.$path('reference.ref.reference.ref', this.data)
    },
    image() {
      const url = getCoverThumbnail(this.$path('media.cover', this.reference) || [])
      if (!url) return

      return { url, name: this.reference.displayName || this.reference.number }
    },
  },
  methods: {
    fetch() {
      let params = new URLSearchParams({ handler: 'get', token: this.token })
      this.promises.fetch = fetch(`/api/action/preset/task-external?${params.toString()}`, {
        method: 'GET',
      })
        .then(res => res.json())
        .then(res => {
          this.data = res.task
          this.comments = res.comments
        })
    },
  },
  metaInfo() {
    return {
      title: `${this.$tc(this.data.type === 'complaint' ? 'complaint' : 'task')} - ${this.data.title}`,
    }
  },
  created() {
    this.fetch()
  },
  components: {
    Metadata,
    Thumbnails,
    FileComponent,
    Card,
    Comments,
  },
}
</script>

<style lang="scss">
.task-external {
  $transform: -8rem;
  background-color: $background-grey;

  &__cover {
    & + .task-external__wrapper {
      transform: translateY($transform);
    }
  }

  &__wrapper {
    padding: 1rem;
    max-width: 960px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 2rem;
  }

  .card__title {
    margin: 0;
    font-size: 1.5em;
    align-self: center;
  }

  &__reference {
    background: linear-gradient(180deg, hsla(0, 0%, 100%, 0.9), #fff 60%);
    backdrop-filter: blur(5px);

    .card__content {
      span {
        font-weight: 700;
        font-size: 1.2rem;
      }

      h1 {
        margin: 0;
      }
    }
  }

  &__content {
    display: flex;
    flex-direction: column;
    gap: 2rem;
    box-shadow: none;
  }
  &__info,
  &__comments {
    .card__header {
      align-items: flex-start;
      min-height: 0;
      h2 {
        margin: 0;
      }
    }
  }

  &__info {
    .task-metadata__type {
      display: none;
    }
    &-description {
      margin: 1rem 0;
      border-left: 2px solid var(--border-color);
      padding: 1rem;
      background-color: hsl(var(--border-color-h), var(--border-color-s), calc(var(--border-color-l) + 9%));
    }
  }

  &__cover {
    background-color: css-alpha('primary', 0.07);
    height: 45vh;
    width: 100%;

    &-wrapper {
      pointer-events: none;
      position: relative;
      overflow: hidden;
      width: 100%;
      height: 100%;

      img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
}
</style>
